import React from 'react';
import moment from 'moment';

export const renderDateInGriddleCell = (data = {}, format) => {
  if (typeof data.value === 'undefined' || data.value === null) {
    return <span />;
  }
  const rawDate = data.value;

  if (typeof format === 'undefined') {
    format = 'DD.MM.YYYY HH:mm';
  }

  return <span>{moment(rawDate).format(format)}</span>;
};

export default renderDateInGriddleCell;



// WEBPACK FOOTER //
// ./src/helpers/renderDateInGriddleCell.js